<template>
  <div class="captcha">
    <div class="captcha__content">
      <div
        class="captcha__image-wrapper"
      >
        <loading
          class="captcha__loader"
          v-show="loading"
        />
        <img
          alt="Captcha"
          class="captcha__image"
          v-show="!loading"
          :src="captchaData.imageBase64"
        />
      </div>
      <div
        class="captcha__input-box"
      >
        <div class="captcha__input-group">
          <label class="captcha__input-label">{{ $t('general.type-characters')}}</label>
          <b-input
            v-model="word"
            :state="$bsStateValidator($v.word.$error)"
          />
        </div>
        <div
          class="captcha__info"
        >
          <div
            class="captcha__reload"
            @click="reload()"
          >
            <span id="captcha-reload" class="fa fa-sync-alt text-blue"></span>
            <b-tooltip
              target="captcha-reload"
              placement="bottom"
            >
              {{ $t('general.captcha-reload') }}
            </b-tooltip>
          </div>
          <div class="captcha__info-label text-gray">
            {{ $t('header.sigma')}}<br />
            {{ $t('general.captcha')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="sass" scoped>
  @import src/styles/defaults/variables
  @import "src/styles/defaults/mobile-first"

  .captcha
    background-color: var(--color-background-regular)
    padding: 5px
    border-radius: 3px
    width: 250px
    box-shadow: 0 0 4px 1px rgba(0,0,0,0.08)
    -webkit-box-shadow: 0 0 4px 1px rgba(0,0,0,0.08)
    -moz-box-shadow: 0 0 4px 1px rgba(0,0,0,0.08)
    overflow: hidden
    display: flex
    flex-direction: column
    &__content
      display: flex
      flex-direction: column
    &__image-wrapper
      height: 70px
      display: flex
      justify-content: center
      align-items: center
    ::v-deep &__loader
      font-size: 2rem
    &__image
      width: auto
      height: 100%
    &__input-box
      display: flex
      flex-direction: row
      font-weight: 600
    &__input-group
      align-self: flex-end
    &__input-label
      font-size: 0.9rem
    &__info
      flex: 1
      margin-top: 5px
      margin-left: 5px
    &__reload
      cursor: pointer
      text-align: center
      font-size: 1.8rem
    &__info-label
      font-size: 0.7rem
      font-weight: 400
      text-align: center
    +media-min-sm()
    +media-min-md()
    +media-min-lg()
</style>

<script>
import { required } from 'vuelidate/lib/validators';
import CaptchaService from '../../services/captchaService';
import Loading from '../Loading';

export default {
  components: {
    Loading,
  },
  props: { },
  data() {
    return {
      word: null,
      loading: false,
      captchaData: {
        validationKey: null,
        imageBase64: null,
      },
      errorAlerts: [],
    };
  },
  validations: {
    word: {
      required,
    },
  },
  methods: {
    validateCaptcha() {
      if (!this.word) {
        this.errorAlerts.push(this.$pushAlert({
          code: 'MA001',
          messageParams: {
            NomeDoCampo: 'Captcha',
          },
        }));
        return Promise.reject();
      }
      return CaptchaService.replyCaptcha({
        validationKey: this.captchaData.validationkey,
        value: this.word,
      });
    },
    reload() {
      this.getCaptcha();
    },
    getCaptcha() {
      this.loading = true;
      this.word = null;
      CaptchaService.getCaptcha()
        .then(({ data }) => {
          this.captchaData.validationkey = data.chaveValidacao;
          this.captchaData.imageBase64 = `data:image/jpeg;base64, ${data.imagemBase64}`;
          this.loading = false;
        });
    },
  },
  computed: {
  },
  created() {
    this.getCaptcha();
  },
};
</script>
